import React, { FC } from 'react';
import { CaddyCardContainerStyled, RodConfigCardStyled } from './styled';
import { Box, Text, Icon, IconSize, Separator, SeparatorType, Avatar, AvatarSize } from '@bechtel/gds';
import { map } from 'lodash';
import { TextWithEllipsis, EllipsisPlacement } from '@bechtel/client-common';
import { CaddyCardProps, RodConfigCardProps } from './types';
import { CaddyFillerMaterialDiameter, CrewMember } from '@bechtel/types';

export const CaddyCard: FC<CaddyCardProps> = ({ caddy, onEditCaddy, onDeleteCaddy, canEditCaddy = false }) => {
  return (
    <CaddyCardContainerStyled data-testid="caddy-card-container">
      <Box justifyContent={{ sm: 'space-between' }} pt={{ sm: '400' }} pl={{ sm: '400' }} pr={{ sm: '450' }}>
        <Box css={{ maxWidth: '75px' }}>
          <TextWithEllipsis size="300" color="grey.600" ellipsisPlacement={EllipsisPlacement.END}>
            {caddy.caddy.label}
          </TextWithEllipsis>
        </Box>
        <Box ml={{ sm: '500' }}>
          {canEditCaddy && (
            <Box mr={{ sm: '450' }}>
              <Icon
                onClick={() => {
                  if (!onEditCaddy) return;
                  onEditCaddy(caddy);
                }}
                size={IconSize.SMALL}
                icon="edit"
                fillColor="bechtel.blue.700"
                style={{ cursor: 'pointer' }}
              />
            </Box>
          )}
          <Icon
            onClick={() => onDeleteCaddy(caddy)}
            size={IconSize.SMALL}
            icon="trash-can"
            fillColor="red.500"
            style={{ cursor: 'pointer' }}
          />
        </Box>
      </Box>
      <Separator type={SeparatorType.HORIZONTAL} spacing="400" color="grey.300" />
      <Box flexDirection={{ sm: 'column' }} flexGrow={{ sm: 1 }} justifyContent={{ sm: 'space-between' }}>
        <Box flexDirection={{ sm: 'column' }} px={{ sm: '450' }}>
          {map(caddy.fillerMaterial.diameters, (rodItem: CaddyFillerMaterialDiameter, index) => {
            return (
              <Box key={index} mb={{ sm: '300' }} data-testid={`rod-config-${index}`}>
                <RodConfigCard rod={rodItem} fillerMaterial={caddy.fillerMaterial.fillerMaterial.label} />
              </Box>
            );
          })}
        </Box>
        <Box alignSelf={{ sm: 'flex-end' }} pr={{ sm: '450' }} pb={{ sm: '400' }}>
          {map(caddy.stencils, (issuedToItem: CrewMember) => {
            return (
              <Box key={issuedToItem.id} ml={{ sm: '100' }} data-testid={`welder-${issuedToItem.id}`}>
                <Avatar size={AvatarSize.SMALL} src={issuedToItem.imageUrl ? issuedToItem.imageUrl : undefined} />
              </Box>
            );
          })}
        </Box>
      </Box>
    </CaddyCardContainerStyled>
  );
};

const RodConfigCard: FC<RodConfigCardProps> = ({ rod, fillerMaterial }) => {
  return (
    <RodConfigCardStyled>
      <Box flexDirection={{ sm: 'column' }} mr={{ sm: '400' }} pr={{ sm: '300' }}>
        <Box mb={{ sm: '100' }}>
          <Text size="300" color="grey.1000">
            {fillerMaterial}
          </Text>
        </Box>
        <Text size="200" color="grey.1000" style={{ opacity: '60%' }}>
          {rod?.heatLotNumber.label}
        </Text>
      </Box>
      <Text size="300" color="grey.1000">
        {rod?.diameter.label}
      </Text>
    </RodConfigCardStyled>
  );
};
